import React from 'react';

import { styled } from '@mui/styles';
import { 
    Avatar, Typography, Button,
} from '@mui/material';

import ButtonBlue from '../../../shared/buttonBlue';

const DivCoverReturn = styled("div")({
    height:"100%",
    display:"flex",
    flexDirection:"column",
    justifyContent:"center",
    gap: "40px"
});

const AvatarStyled = styled(Avatar)(({theme})=>({
    width: "280px",
    height: "280px",
    "& img": {
        objectPosition: "5px 6px",
    },
    boxShadow:theme.shadows[3],
    backgroundColor:"white",
}));

const ConFirmCarText = styled(Typography)({
    conFirmCarText:{
        marginTop:"30px",
        fontSize:"30px",
    },
});

const CarVerification = (props) => {
    return(
        <DivCoverReturn>
            <AvatarStyled
                src={`${process.env.REACT_APP_URL}image/car/car1.png`}
                alt="car1.png"
            />
            {/* <ConFirmCarText>ยืนยันให้รถมารับ</ConFirmCarText> */}
            <ButtonBlue variant="contained" onClick={props.onClickNextPage}>เรียกรถ</ButtonBlue>
        </DivCoverReturn>
    );
};

export default CarVerification;